function Poland({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1928)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
  <path d="M32 16C32 24.8365 24.8365 32 16 32C7.1635 32 0 24.8365 0 16" fill="#D80027"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Poland;
